import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { BehaviorSubject } from 'rxjs';
import { UtilityService } from '../utility/utility.service';
@Injectable({
  providedIn: 'root',
})
export class NotificationsService {
  constructor(private api: ApiService, private utility: UtilityService) {
    setInterval(() => {
      this.getNotifications();
    }, 100000);
  }
  bellTrigger = false;
  private isFirstLoad = true;
  private unreadCount = 0;
  NOTIFICATIONS: any[] = [];
  bellTriggerSubject = new BehaviorSubject<boolean>(false);
  notificationLightSubject = new BehaviorSubject<boolean>(false);
  notificationsSubject = new BehaviorSubject<any[]>([]);
  // 1. subject belltrigger
  // 2. subject notification
  getNotifications(activeId = 0) {
    this.api.getNotifications(0).subscribe(
      (res: any) => {
        if (res && res.message) {
          this.NOTIFICATIONS = res.message;
          this.notificationsSubject.next(this.NOTIFICATIONS);
          // }
        }
      },
      (error) => {
        this.utility.alertError(
          error?.error?.error || 'Unknown Error Occured.'
        );
        console.log('Error fetching notifications:', error);
      },
      () => {
        //   let unreadInLastSix = false;
        //   const unreadNotifications = this.NOTIFICATIONS.filter(
        //     (notification) => notification.read_receipt === 0
        //   );
        //   const newUnreadCount = unreadNotifications.length;
        //   // this.notificationLightSubject.next(true);
        //   for (let i = 0; i < Math.min(6, this.NOTIFICATIONS.length); i++) {
        //     if (this.NOTIFICATIONS[i].read_receipt === 0) {
        //       unreadInLastSix = true;
        //       break;
        //     }
        //   }
        //   if (!this.isFirstLoad) {
        //     if (newUnreadCount > this.unreadCount) {
        //       this.bellTriggerSubject.next(true);
        //       this.playNotificationSound();
        //     } else {
        //       this.bellTriggerSubject.next(false);
        //     }
        //   } else {
        //     if (unreadInLastSix) {
        //       // if (!this.bellTriggerSubject.getValue()) {
        //       this.playNotificationSound();
        //       // }
        //       this.bellTriggerSubject.next(true);
        //     }
        //     this.isFirstLoad = false;
        //   }
        //   this.unreadCount = newUnreadCount;
        // }
        this.handleNotificationAfterFetch();
      }
    );
    // bellTrigger should be true only when
    // 1. any of the last 6 notifications is unread
    // 2. after the first api call get the total unread notifications,
    // if number of unread notifications increases, then trigger.
    // For the above case, trigger the bell and notification light.
  }
  private handleNotificationAfterFetch() {
    let unreadInLastSix = false;
    const unreadNotifications = this.NOTIFICATIONS.filter(
      (notification) => notification.read_receipt === 0
    );
    const newUnreadCount = unreadNotifications.length;
    // Check if all notifications are read
    const allRead = this.NOTIFICATIONS.every(
      (notification) => notification.read_receipt === 1
    );
    for (let i = 0; i < Math.min(6, this.NOTIFICATIONS.length); i++) {
      if (this.NOTIFICATIONS[i].read_receipt === 0) {
        unreadInLastSix = true;
        break;
      }
    }
    if (!this.isFirstLoad) {
      if (newUnreadCount > this.unreadCount) {
        this.bellTriggerSubject.next(true);
        this.playNotificationSound();
        this.notificationLightSubject.next(true);
      } else {
        this.bellTriggerSubject.next(false);
      }
    } else {
      if (unreadInLastSix) {
        this.playNotificationSound();
        this.bellTriggerSubject.next(true);
        this.notificationLightSubject.next(true);
      }
      this.isFirstLoad = false;
    }
    this.unreadCount = newUnreadCount;
    // If all notifications are read, turn off the notification light
    if (allRead) {
      this.notificationLightSubject.next(false);
    }
  }
  playNotificationSound() {
    const audio = new Audio('assets/sounds/notification-sound.mp3');
    audio.play().catch((error) => {
      console.error('Failed to play notification sound:', error);
    });
  }
}
